import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { NavMarker } from 'react-rhumb';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EmptyTable = ({
  navMarkerName,
  onResetClick
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [navMarkerName && /*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName
    }), /*#__PURE__*/_jsx(ErrorMessage, {
      illustration: "empty-state-charts",
      title: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.common.emptyTable.title"
        })
      }),
      children: /*#__PURE__*/_jsxs("p", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.common.emptyTable.description"
        }), /*#__PURE__*/_jsx("br", {}), onResetClick && /*#__PURE__*/_jsx(Button, {
          marginBlockStart: "200",
          onClick: onResetClick,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.common.emptyTable.resetFilters"
          })
        })]
      })
    })]
  });
};
export default EmptyTable;